import React from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';

const CustomTooltip = React.forwardRef(({ placement = 'topLeft', children, ...rest }, ref) => {
  return (
    <Tooltip ref={ref} placement={placement} {...rest}>
      {children}
    </Tooltip>
  );
});

CustomTooltip.propTypes = {
  placement: PropTypes.string,
  children: PropTypes.node.isRequired, // Ensure children are valid React nodes
};

export default CustomTooltip;
